
import { _replaceAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}

import cfg0 from "/var/www/frontend_build/.app/app.config.ts"
import cfg1 from "/var/www/frontend_build/layers/tairo-layout-sidebar/app.config.ts"
import cfg2 from "/var/www/frontend_build/layers/tairo-layout-collapse/app.config.ts"
import cfg3 from "/var/www/frontend_build/layers/tairo-layout-topnav/app.config.ts"
import cfg4 from "/var/www/frontend_build/layers/tairo/app.config.ts"
import cfg5 from "/var/www/frontend_build/node_modules/.pnpm/@shuriken-ui+nuxt@1.1.3_nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.0_@vue+compiler-s_xfiqmue5yuzzgu7yp6ymqpm37m/node_modules/@shuriken-ui/nuxt/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, cfg1, cfg2, cfg3, cfg4, cfg5, inlineConfig)
